import './component.scss'

import './images/site_logo.svg'
import './images/jpx_logo.png'
import './images/company_logo.svg'

// グループサイトのプルダウン機能
import { Controller } from "stimulus"

class FooterController extends Controller {
  static targets = ["content"]

  toggle() {
    const content = this.contentTarget

    // is-hiddenクラスの付け外しで表示/非表示を制御
    content.classList.toggle("is-hidden")
  }
}

// StimulusJSに登録
window.Stimulus.register('nurikae--footer--component', FooterController)
